import { render, staticRenderFns } from "./resultmore.vue?vue&type=template&id=57c96b8f&scoped=true&"
import script from "./resultmore.vue?vue&type=script&lang=js&"
export * from "./resultmore.vue?vue&type=script&lang=js&"
import style0 from "./resultmore.vue?vue&type=style&index=0&id=57c96b8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c96b8f",
  null
  
)

export default component.exports